// Vendor imports
const Cookies = require('js-cookie')
// Client V1 libs
const cookieLib = require('client/lib/cookie')
// Client V2 common imports
const extension = require('client-v2/common/utils/extension')

// Action types

const BROWSER_IS_ACTUALLY_AN_IPAD = 'ENVIRONMENT_BROWSER_IS_ACTUALLY_AN_IPAD'
const UPDATE_EXTENSION_INSTALLED = 'ENVIRONMENT_UPDATE_EXTENSION_INSTALLED'

// Action dispatchers

function detectBrowser() {
  return function (dispatch, getState) {
    const { browser } = getState().env
    /**
     * iPads report themselves as Desktop Safari as of iOS 13, so we need to
     * do client-side feature tests to see through Apple's lying user-agent.
     * @see https://51degrees.com/blog/missing-ipad-tablet-web-traffic
     */
    if (browser.get('webkit') && browser.get('isDesktop')) {
      const isIpadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)
      if (isIpadOS) {
        dispatch({ type: BROWSER_IS_ACTUALLY_AN_IPAD })
        Cookies.set('device_override', 'iPad', cookieLib.setAttributes('device_override'))
        return
      }
    }
    Cookies.remove('device_override', cookieLib.clearAttributes('device_override'))
  }
}

function detectExtension() {
  return function (dispatch, getState) {
    const wasInstalled = getState().env.extensionInstalled
    const isInstalled = extension.isInstalled()
    if (isInstalled && !Cookies.get('mix-ext')) {
      Cookies.set('mix-ext', '1', cookieLib.setAttributes('mix-ext'))
    } else if (!isInstalled) {
      Cookies.remove('mix-ext', cookieLib.clearAttributes('mix-ext'))
    }
    if (wasInstalled !== isInstalled) {
      dispatch({
        type: UPDATE_EXTENSION_INSTALLED,
        payload: isInstalled
      })
    }
  }
}

// Exports

module.exports = {
  // Action types
  BROWSER_IS_ACTUALLY_AN_IPAD,
  UPDATE_EXTENSION_INSTALLED,
  // Action dispatchers
  detectBrowser,
  detectExtension
}
